import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FlightInboundFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.5145 21.2558C22.5145 20.8458 22.1745 20.5058 21.7445 20.5058H3.27447C2.84447 20.5058 2.50447 20.8458 2.50447 21.2558C2.50447 21.6658 2.84447 22.0058 3.27447 22.0058H21.7445C22.1745 22.0058 22.5145 21.6658 22.5145 21.2558Z"
				fill="currentColor"
			/>
			<path
				d="M6.89491 4.49105C5.8752 4.32081 4.70338 4.50363 3.87049 4.95216L2.81953 5.50709L2.80433 5.51513L2.25092 5.82319C0.96699 6.5885 1.12971 7.97753 2.5096 8.44617L3.1312 8.6435L7.77878 10.056L12.6165 16.1282C12.7071 16.2418 12.8325 16.3238 12.9728 16.3615L15.7611 17.111C16.0096 17.1775 16.2749 17.0976 16.4459 16.9053C16.6169 16.7129 16.6645 16.4399 16.5691 16.2008L14.7427 11.6233L18.8251 12.1933C19.043 12.2237 19.2626 12.1465 19.4138 11.9867L22.8592 8.34395C23.0252 8.1682 23.0857 7.91757 23.0178 7.68555C22.9496 7.45332 22.7623 7.27419 22.5273 7.21609L20.1089 6.61857L20.0386 6.60465C19.8748 6.58205 19.7072 6.62024 19.5682 6.71284L18.2578 7.58736L14.9351 6.6778L14.9372 6.67536L7.72825 4.70362L7.72861 4.70167L7.13154 4.53838L7.11462 4.53402L7.09684 4.5299L6.89491 4.49105Z"
				fill="currentColor"
			/>
			<path
				d="M15.22 2.12511L10.9335 4.16943L15.9751 5.54813L17.7997 3.56762C17.9657 3.38743 18.0226 3.13165 17.9478 2.89839C17.8726 2.66516 17.6775 2.48976 17.4375 2.44015L15.6501 2.07269L15.541 2.05881C15.431 2.05431 15.3204 2.07723 15.22 2.12511Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FlightInboundFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FlightInboundFilledIcon;
